module.exports = __webpack_public_path__ + "static/media/ic_emptyList.83e1de95.svg";